// angular
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
// app
import { AppAnimations } from 'src/app/_shared/animations';
import { DataSharingService } from 'src/app/_core/services';
import { RestResponse } from 'src/app/_shared/models';
import { CompanyCurrency } from 'src/app/_shared/models';
// rxjs
import { SharedGlobalService } from 'src/app/_core/services/api/shared-global.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
@Component({
  animations: [ AppAnimations ],
  selector: 'app-billing-operation-dashboard',
  templateUrl: './billing-operation-dashboard.component.html',
  styleUrls: ['./billing-operation-dashboard.component.scss'],
})

export class BillingOperationDashboardComponent implements OnInit, OnDestroy {
  collectionOfBillingActivity: Array<any> = [];
  collectionOfPaymentActivity: Array<any> = [];
  collectionOfPaymentActivityDates: Array<any> = [];
  collectionOfPaymentTotals: Array<any> = [];
  companyCurrencyBase: CompanyCurrency;
  isActivityError: boolean = false;
  isPaymentActivityReady: boolean = false;
  paymentActivitySeries: Array<any> = [];

  private subs = new Unsubscriber();
  
  constructor(
    private meta: MetaService,
    private sharedGlobalService: SharedGlobalService,
    private shareData: DataSharingService,
  ) {
    // Subscribe to company currency base
    this.subs.addSub = this.shareData.currentCompanySettingsCurrencyBaseSource.subscribe(data => {
      this.companyCurrencyBase = data.currencyBase;
    });
  }

  getPaymentActivity() {
    this.subs.addSub = this.sharedGlobalService.getPaymentActivity().subscribe(
        (res: any) => {
          let lineColor = '';
          this.collectionOfPaymentActivityDates = res.data.activity.dates;
          this.collectionOfPaymentActivity = <Array<any>>res.data.activity.data;
          this.collectionOfPaymentTotals = <Array<any>>res.data.totals;
          this.collectionOfPaymentActivity.map(item => {
            switch (item.keyName) {
              case 'posted':
                lineColor = '#276BEE';
                break;
              case 'paid':
                lineColor = '#04D28F';
                break;
              case 'awaitingSettlement':
              case 'processing':
                lineColor = '#9CA7B6';
                break;
              case 'refund':
                lineColor ='orange';
                break;
              case 'overDue':
                lineColor ='red'; 
                break;
            }
          
            this.paymentActivitySeries.push({
              name: item.keyName,
              data: item.data.map(({ count }) => count),
              type: 'line',
              color: lineColor,
              areaStyle: {},
              lineStyle: {
                width: 2
              },
              emphasis: {
                focus: 'series'
              },
              smooth: true
            });
          });
          
          this.isPaymentActivityReady = true;
          this.isActivityError = false;
        },
        (err: RestResponse) => {
          this.meta.showNotification(err);
          this.isPaymentActivityReady = true;
          this.isActivityError = true;
        }
      );
  }

  ngOnInit() {
    this.getPaymentActivity();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
